import React, { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const Cutlery: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" {...rest}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Cutlery" stroke="#222222" strokeWidth="2">
          <g id="Group" transform="translate(4.500000, 2.000000)">
            <line x1="2.72727273" y1="0" x2="2.72727273" y2="20" id="Path" />
            <path
              d="M5.45454545,0 L5.45454545,6 C5.45005254,7.47093582 4.23163891,8.6622736 2.72727273,8.66666667 L2.72727273,8.66666667 C1.22290655,8.6622736 0.00449291061,7.47093582 0,6 L0,0"
              id="Path"
            />
            <line x1="12.2727273" y1="8.66666667" x2="12.2727273" y2="20" id="Path" />
            <rect id="Rectangle" x="9.54545455" y="0" width="5.45454545" height="8.66666667" rx="1.77777778" />
          </g>
        </g>
      </g>
    </svg>
  );
};
